<template>
  <div class="contents">
    <ContactShell @submit="submitRequest">
      <template #content>
        <LrrInfoBlock v-if="lrrIsOngoing" />
      </template>
    </ContactShell>
  </div>
</template>

<script lang="ts" setup>
import { computed, watch } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTheToast } from '@backmarket/nuxt-module-toast/useTheToast'

import type {
  ContactEvents,
  MachineSend,
} from '@/scopes/customer-care/resolution/machine/ResolutionFlow.machine.types'
import { useCheckForLrr } from '~/scopes/care-commons/composables/useCheckForLrr'
import LrrInfoBlock from '~/scopes/customer-care/resolution/components/common/LrrInfoBlock/LrrInfoBlock.vue'

import type { ContactFormValues } from '../../../common/ContactShell/ContactShell.types'
import ContactShell from '../../../common/ContactShell/ContactShell.vue'

import translations from './RemoteAssistanceContactScreen.translations'
import type { RemoteAssistanceContactScreenProps } from './RemoteAssistanceContactScreen.types'

const props = defineProps<RemoteAssistanceContactScreenProps>()
const { lrrIsOngoing } = useCheckForLrr()

const i18n = useI18n()
const { openErrorToast } = useTheToast()

const send = props.machineSend as MachineSend<ContactEvents>

const hasSubmitError = computed(() =>
  props.machineState.matches('CONTACT.SUBMISSION_ERROR'),
)

function submitRequest(payload: ContactFormValues) {
  send({
    type: 'CONTACT_REFURBISHER',
    payload: {
      description: payload.details,
      pictures: payload.files,
    },
  })
}

watch(
  hasSubmitError,
  (isError) => {
    if (isError) {
      openErrorToast({
        title: i18n(translations.errorToastTitle),
        content: i18n(translations.errorToastDescription),
        closeCallback: () => send('GO_TO_FORM'),
        name: 'resolution-flow-remote-assistance-contact-screen-submition-error-toast',
      })
    }
  },
  { immediate: true },
)
</script>
